import { DialogContent, DialogActions, Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Wrapper = styled(Box)``

export const Header = styled(Box)`
  padding: 8px 16px 16px;
  border-bottom: 1px solid ${theme.colors.analyzerBorder};

  .title {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.normal};
    font-size: 36px;
    line-height: 44px;
    color: ${theme.colors.menuItemText};
  }
`

export const Content = styled(DialogContent)`
  padding: ${theme.spacing.medium}px 58px 48px;

  .MuiFormControl-root {
    margin-bottom: ${theme.spacing.medium}px;

    label {
      color: ${theme.colors.devicesSecondaryText};

      .MuiInputLabel-asterisk {
        color: #fe455d;
      }
    }

    .MuiOutlinedInput-root {
      border-radius: ${theme.attributes.borderRadius.small};
      color: ${theme.colors.devicesSecondaryText};
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.xLarge};
      line-height: 24px;
      letter-spacing: 0.5px;

      fieldset {
        border: 1px solid ${theme.colors.controlBorder} !important;
      }
    }

    .MuiFormHelperText-root {
      margin-left: 0;
      color: ${theme.colors.errorLight};

      html[data-theme='light'] & {
        color: ${theme.colors.inputError};
      }
    }
  }

  .roles-wrapper {
    .roles-title {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.xxLarge};
      line-height: 28px;
      color: ${theme.colors.menuItemText};

      span {
        color: #fe455d;
      }
    }

    .MuiFormGroup-root {
      .MuiFormControlLabel-root {
        display: flex;
        align-items: flex-start;
        margin-left: ${theme.spacing.xSmall}px;

        &:not(:last-of-type) {
          margin-bottom: ${theme.spacing.small}px;
        }

        &:first-of-type {
          margin-top: ${theme.spacing.xSmall}px;
        }

        .MuiRadio-root {
          padding: 2px 0 0;

          svg {
            width: 20px;
            height: 20px;

            path {
              fill: ${theme.colors.devicesSecondaryText};
            }
          }
        }

        .roles-name {
          font-family: ${theme.typography.fontFamily.primary};
          font-weight: ${theme.typography.fontWeight.normal};
          font-size: ${theme.typography.fontSize.xLarge};
          line-height: 24px;
          letter-spacing: 0.5px;
          color: ${theme.colors.menuItemText};
          margin-left: 18px;
        }

        .roles-description {
          font-family: ${theme.typography.fontFamily.primary};
          font-weight: ${theme.typography.fontWeight.normal};
          font-size: ${theme.typography.fontSize.medium};
          line-height: 16px;
          letter-spacing: 0.4px;
          color: ${theme.colors.devicesSecondaryText};
          margin-left: 18px;
        }
      }
    }
  }
`

export const Actions = styled(DialogActions)`
  background: ${theme.colors.backgroundDarker};
  box-shadow: ${theme.attributes.boxShadow.toolbar};
  border-radius: 0 0 16px 16px;
  padding: 16px 36px;

  .MuiButtonBase-root {
    &:last-of-type {
      margin-left: 24px;
    }
  }
`
